let authenticatedUserUuid: string | undefined

export function setMetaAuthenticatedUserUuid(uuid: string | undefined): void {
  authenticatedUserUuid = uuid?.trim() || undefined
}

export function getMetaAuthenticatedUserUuid(): string | undefined {
  return authenticatedUserUuid
}
